// extracted by mini-css-extract-plugin
export default {"title":"Notifications_title__T+RBL","more":"Notifications_more__LN+VE","details":"Notifications_details__N9Nor"};